function gracefulErrorHandler(err) {
  console.error(err);
  return [];
}

export default gracefulErrorHandler;


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/api/error.js
 **/